/*
 * Background videos from snippets/responsive-video.liquid (video[data-lazy-video]).
 * They load with preload="none" and no autoplay; a video plays while it is in
 * view and pauses when it leaves, so videos further down the page only
 * download when the visitor reaches them. They play regardless of the
 * device's reduced-motion setting (the store's choice); the poster shows only
 * until the first frame, or where the browser refuses playback.
 */
(function () {
  function play(video) {
    var attempt = video.play();
    // Autoplay can be refused (power saving); the video then stays on its first frame.
    if (attempt && attempt.catch) attempt.catch(function () {});
  }

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) play(video);
          else if (!video.paused) video.pause();
        });
      }, { rootMargin: '200px 0px' })
    : null;

  function setup(root) {
    (root || document).querySelectorAll('video[data-lazy-video]:not([data-lazy-video-bound])').forEach(function (video) {
      video.setAttribute('data-lazy-video-bound', '');

      if (observer) observer.observe(video);
      else play(video);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); });
  else setup();

  // Sections re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) { setup(event.target); });
})();
